export default () => {
	document.querySelectorAll('h1, h2, h3, h4, h5, blockquote, p, span, a:not(.footer-teaser)').forEach(text => {
		let pos = text.innerHTML.toLowerCase().indexOf('mentalboxen')
		if (pos != -1) {
			text.innerHTML = text.innerHTML.substr(0, pos + 6) + '<wbr>' + text.innerHTML.substr(pos + 6)
		}
	})
}